export var ChatCardTypeTokens;
(function (ChatCardTypeTokens) {
    ChatCardTypeTokens["sender"] = "sender";
    ChatCardTypeTokens["receiver"] = "receiver";
    ChatCardTypeTokens["reply"] = "reply";
})(ChatCardTypeTokens || (ChatCardTypeTokens = {}));
